module.exports = __webpack_public_path__ + "static/security-aaa6b466faeda4cbe177fe898728b516.svg";